import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { fetchStudentAssignments, studentAssignmentSubmit } from '../../redux/action/studentAction';
import { Link, useHistory } from 'react-router-dom';
import HomeHelper from '../../Components/HomeHelper';
import Footer from '../../Components/Footer';
import Loading from '../../Components/Loading';

const StudentAssignment = () => {
    const store = useSelector((store) => store);
    const history = useHistory();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);
    
    // Use an object to store the individual form state for each assignment
    const [assignmentFormState, setAssignmentFormState] = useState({});

    const department = store.student.student.student.department;
    const semester = store.student.student.student.semester;

    useEffect(() => {
        // Fetch student assignments when the component mounts
        dispatch(fetchStudentAssignments({ department, semester }))
            .then(() => setLoading(false))
            .catch((error) => {
                console.error('Error fetching assignments:', error);
                setLoading(false);
            });
    }, [dispatch]);

    const formHandler = (e, assignmentId, dueDate) => {
        e.preventDefault();
    
        const student_id = store.student.student.student?._id;
        const currentDate = new Date().toISOString();
        const urlRegex = /^(ftp|http|https):\/\/[^ "]+$/;
    
        // Access the specific state for the assignment
        const assignmentState = assignmentFormState[assignmentId];
    
        if (!urlRegex.test(assignmentState.yourWorkLink)) {
            // Show an alert or handle the error in your preferred way
            alert('Invalid URL! Please enter a valid link.');
            return;
        }
    
        // Check if the current date is past the due date
        const isPastDueDate = new Date(currentDate) > new Date(dueDate);
    
        if (isPastDueDate) {
            // Show an alert or take other action to indicate that the assignment cannot be submitted
            alert('Assignment submission is not allowed after the due date.');
            return;
        }
    
        // Create the student assignment data
        const studentAssignmentSubmitData = {
            student_id,
            yourWorkLink: assignmentState.yourWorkLink,
            currentDate,
            assignmentId
        };
    
        // Log the created student assignment data
        console.log(studentAssignmentSubmitData);
    
        // Dispatch the action with the student assignment data
        dispatch(studentAssignmentSubmit(studentAssignmentSubmitData));
    };
    
    

    return (
        <div>
            {store.student.isAuthenticated ? (
                <>
                    <HomeHelper />
                    <div className='mainHome'>
                        <div className="container-fluid main" style={{ backgroundImage: 'url("/image/pattern.png")', backgroundRepeat: 'repeat' }}>
                            <div className='px-4 py-1 bg-light d-flex align-items-center justify-content-between'>
                                <h3> <img src="logo192.png" width={'50px'} alt="" /> Assignment's</h3>
                                <button onClick={() => window.print()} type="button" className=" print-helper btn-success btn text-light"> <img src="/image/print.svg" alt="" /> Download</button>
                            </div>
                            {loading ? (
                                <Loading />
                            ) : (
                                <ol className='list-group'>
                                    {store.student.studentAssignments.map((assignment) => (
                                        <li key={assignment._id} className='list-group-item bg-light d-flex align-items-center justify-content-between w-80 m-3'>
                                            <div>
                                                <h5>Subject: {assignment.subject.subjectName} </h5>
                                                <p className='mb-1'>Assignment Title: {assignment.title}</p>
                                                <p>Due date: {new Date(assignment.submissionDate).toLocaleDateString()}</p>
                                                <small className="badge badge-secondary">Given date:{new Date(assignment.givenDate).toLocaleDateString()}</small>
                                            </div>
                                            <div>
                                                <button type="button" className=" btn-info w-100 mt-2 btn text-light" data-bs-toggle="modal" data-bs-target={`#exampleModal-${assignment._id}`}>
                                                    Open
                                                </button>

                                                <div className="modal fade" id={`exampleModal-${assignment._id}`} tabIndex="-1" aria-labelledby={`exampleModalLabel-${assignment._id}`} aria-hidden="true">
                                                    <div className="modal-dialog  modal-lg">
                                                        <div className="modal-content">
                                                            <div className="modal-header">
                                                                <h5 className="modal-title fs-5" id={`exampleModalLabel-${assignment._id}`}>{assignment.subject.subjectName} <span className="badge badge-secondary">Assignment.No:{assignment.assignmentNo}</span></h5>
                                                            </div>
                                                            <div className="modal-body">
                                                                <form noValidate onSubmit={(e) => formHandler(e, assignment._id)}>
                                                                    <div className="card mb-3">
                                                                        <img src={assignment.attachment} className="card-img-top" alt="..." />
                                                                        <div className="card-body">
                                                                            <h5 className="card-title">{assignment.title}</h5>
                                                                            <p className="card-text">{assignment.description}</p>
                                                                            <p className="card-text"><small className="text-body-secondary">Due date: {new Date(assignment.submissionDate).toLocaleDateString()}</small></p>
                                                                        </div>
                                                                    </div>
                                                                    <div className="mb-3">
                                                                        <label htmlFor={`yourWork-${assignment._id}`} className="form-label">
                                                                            Your work
                                                                        </label>
                                                                        <input
                                                                            type="url"
                                                                            className="form-control"
                                                                            id={`yourWork-${assignment._id}`}
                                                                            placeholder="Enter your work driveLink"
                                                                            required
                                                                            onChange={(e) => setAssignmentFormState({
                                                                                ...assignmentFormState,
                                                                                [assignment._id]: { yourWorkLink: e.target.value }
                                                                            })}
                                                                        />
                                                                    </div>
                                                                    <button type="submit" className="btn btn-success m-1">
                                                                        Mark as done
                                                                    </button><br />
                                                                    <small><em>!! Work cannot be turned in after the due date !!</em></small>
                                                                </form>
                                                            </div>
                                                            <div className="modal-footer">
                                                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                                                                    Close
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    ))}
                                </ol>
                            )}
                        </div>
                    </div>
                </>
            ) : (
                history.push('/')
            )}
            <Footer />
        </div>
    );
};

export default StudentAssignment;
